import { LocationType, ProductLocation } from '@ng-cloud/badger-core/models/product-location';

import * as _ from 'lodash';

export class Product {
  static readonly UNKNOWN = 'unknown';

  skuId: number;
  sku: string;
  clientSku: string;
  gtin: string;
  name: string;
  locations: ProductLocation[];
  skuMetadata: any;

  locationCount = 0;
  itemCount = 0;

  deserialize(json: any): this {
    this.name = json.name;
    this.skuId = json.sku_id;
    this.sku = json.sku;
    this.clientSku = json.client_sku;
    this.gtin = json.gtin;
    this.locations = json.locations ? json.locations.map((location: any, index: number) => new ProductLocation().deserialize(location, index)) : [];
    this.skuMetadata = json.customer_sku_metadata;

    const counts = _.countBy(this.locations, 'locationType');
    this.locationCount = (counts[LocationType.VIEWPORT] || 0) + (counts[LocationType.TOP_STOCK] || 0);
    this.itemCount = counts[LocationType.RFID] || 0;

    return this;
  }

  getDisplayName(): string {
    return this.name || this.gtin || this.sku;
  }

  hasMatch(searchTokens: string[]): boolean {
    const hasMatch =
      this.matchKeywords(this.name, searchTokens) ||
      this.matchKeywords(this.sku, searchTokens) ||
      this.matchKeywords(this.clientSku, searchTokens) ||
      this.matchKeywords(this.gtin, searchTokens) ||
      _.some(this.locations, (location) =>
        this.matchKeywords(location.epc, searchTokens) ||
        this.matchKeywords(location.serialNumber, searchTokens));

    // TODO: ADD meta data search?!?!?
    return hasMatch;
  }

  matchKeywords(text: string, keys: string[]): boolean {
    if (!text) {
      return false;
    }

    return keys.every(key => text.toLowerCase().includes(key));
  }
}
